import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutReverseTransferSettlementStepper extends Layout {
    reverseTransferSettlementEditStep: Step;
    reverseTransferSettlementPostStep: Step;
    reverseTransferSettlementStepper: Stepper;
}
